import { useCallback, useMemo, useState } from "react";

import * as ModelConverter from "@/components/features/_model/converter";

import * as Factory from "./factory";
import * as FormModelType from "./type";
import * as ValidationSchema from "./validation-schema";

export const usePaymentCreditFormModel = (
	initInputModel: FormModelType.PaymentDepositAccountFormModel["InputModel"],
) => {
	const defaultInputModel = useMemo(
		() => Factory.Default.paymentDepositAccountInputModelFactory(initInputModel.hotelID),
		[initInputModel.hotelID],
	);

	// InputModel の初期化
	const [currentInputModel, setCurrentInputModel] =
		useState<FormModelType.PaymentDepositAccountFormModel["InputModel"]>(initInputModel);

	// ViewModel の初期化
	const [viewModel, setViewModel] = useState<FormModelType.PaymentDepositAccountFormModel["ViewModel"]>(
		ModelConverter.inputModelToViewModelConverter<
			FormModelType.PaymentDepositAccountFormModel["InputModel"],
			FormModelType.ExcludeKeys,
			FormModelType.PaymentDepositAccountFormModel["QueryData"],
			ValidationSchema.PaymentDepositAccountInputZodSchemaType
		>({
			defaultInput: defaultInputModel,
			initInput: initInputModel,
			currentInput: initInputModel,
			excludeKeys: FormModelType.excludeKeys,
			zodSchema: ValidationSchema.PaymentDepositAccountInputZodSchema,
		}),
	);

	// ViewModel の更新
	const onSetViewModel = useCallback(
		(_viewModel: FormModelType.PaymentDepositAccountFormModel["ViewModel"]) => {
			const convertedInputModel = ModelConverter.viewModelToInputModelConverter(_viewModel);
			const convertedViewModel = ModelConverter.inputModelToViewModelConverter<
				FormModelType.PaymentDepositAccountFormModel["InputModel"],
				FormModelType.ExcludeKeys,
				FormModelType.PaymentDepositAccountFormModel["QueryData"],
				ValidationSchema.PaymentDepositAccountInputZodSchemaType
			>({
				defaultInput: defaultInputModel,
				initInput: initInputModel,
				currentInput: convertedInputModel,
				excludeKeys: FormModelType.excludeKeys,
				zodSchema: ValidationSchema.PaymentDepositAccountInputZodSchema,
			});
			// state の更新
			setCurrentInputModel(convertedInputModel);
			setViewModel(convertedViewModel);
		},
		[defaultInputModel, initInputModel],
	);

	// ViewModel のリセット
	const onResetViewModel = useCallback(() => {
		setViewModel((prev) => ({
			...prev,
			isDirty: false,
		}));
	}, []);

	return {
		inputModel: currentInputModel,
		viewModel,
		onSetViewModel,
		onResetViewModel,
	};
};
